import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from as observableFrom, of as observableOf } from 'rxjs';
import { catchError, first, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { PoliciesLoadSuccess } from '@amfam/policy/data-access/lib/+state/policies/policies.actions';

import { ESignatureService } from '../services/e-signature.service';
import {
  GetESignature,
  GetESignatureComplete,
  GetESignatureFail,
  GetESignatureSuccess,
  SignESignature,
  SignESignatureComplete,
  SignESignatureSuccess
} from './e-signature.actions';

export const loading = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(PoliciesLoadSuccess),
      map(action => action.payload),
      switchMap(payload => observableOf(GetESignature(payload)))
    );
  },
  { functional: true }
);

export const getESignature = createEffect(
  (actions$ = inject(Actions), eSignatureService = inject(ESignatureService)) => {
    return actions$.pipe(
      ofType(GetESignature),
      map(action => action.payload),
      switchMap(() => eSignatureService.requiresSignature()),
      mergeMap(response => {
        return observableFrom([GetESignatureComplete(), GetESignatureSuccess(response)]);
      }),
      catchError(error => observableOf(GetESignatureFail(error)))
    );
  },
  { functional: true }
);

export const sign = createEffect(
  (actions$ = inject(Actions), eSignatureService = inject(ESignatureService)) => {
    return actions$.pipe(
      ofType(SignESignature),
      map(action => action.payload),
      switchMap(payload => eSignatureService.requestSignature(payload)),
      map((response: string) => SignESignatureSuccess(response))
    );
  },
  { functional: true }
);

export const signed = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(SignESignatureSuccess),
      map(action => action.payload),
      first(),
      tap(payload => (location.href = payload)),
      map(payload => SignESignatureComplete(payload))
    );
  },
  { functional: true }
);
